import classNames from "classnames";
import React, { PropsWithChildren, ReactElement } from "react";
import { withDefault } from "../../utils/withDefault";
import { TextColor } from "../Generic/ThemeTypes";

type AppButtonColor = "primary" | "danger" | "warning";
type AppButtonVariation = "filled" | "outline";

interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color?: AppButtonColor;
  textColor?: TextColor;
  className?: string;
  variation?: AppButtonVariation;
}

export function CardButton(props: PropsWithChildren<Props>): ReactElement {
  return (
    <button
      {...props}
      className={classNames(props.className, "CardButton")}
      data-color={withDefault(props.color, "primary")}
      data-text-color={props.textColor}
      data-variation={withDefault(props.variation, "filled")}
    >
      {props.children}
    </button>
  );
}
